import React, { useState, useEffect } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { Link } from "../components/L";
import { useParams } from "react-router-dom";
import axios from "axios";
import useSEO from "../hooks/useSEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BlogPostPage = () => {
  const { tx } = useLanguage();
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [related, setRelated] = useState([]);

  useSEO({
    title: post ? post.title : tx("Artikull Blog"),
    description: post ? (post.excerpt || post.content?.substring(0, 160)) : tx("Artikull nga Albanian Aligners Academy."),
    keywords: post ? `${post.title}, ${post.category}, blog dentar, albanian aligners academy` : "blog dentar",
    ogImage: post?.cover_image,
    canonical: `https://aligners.academy/blog/${id}`,
  });

  useEffect(() => {
    axios.get(`${API}/blog/${id}`).then(r => {
      setPost(r.data);
      axios.get(`${API}/blog`).then(r2 => {
        setRelated(r2.data.filter(p => p.id !== id && p.category === r.data.category).slice(0, 3));
      });
    }).catch(() => {});
  }, [id]);

  if (!post) return <div className="min-h-screen flex items-center justify-center"><p className="text-[#828D9E]">{tx("Duke ngarkuar...")}</p></div>;

  const imgSrc = post.cover_image && post.cover_image.startsWith("/api/files/")
    ? `${process.env.REACT_APP_BACKEND_URL}${post.cover_image}`
    : post.cover_image || "https://images.pexels.com/photos/23625648/pexels-photo-23625648.jpeg";

  return (
    <div data-testid="blog-post-page">
      {/* Hero - breadcrumb+title left, image right */}
      <section className="relative overflow-hidden" style={{ background: 'linear-gradient(130deg, #3CD4E1 0%, #003F72 100%)' }}>
        <div className="max-w-[1350px] mx-auto grid grid-cols-1 lg:grid-cols-2 min-h-[350px] relative z-10">
          {/* Left - text */}
          <div className="flex flex-col justify-center py-14 px-6 md:px-12 relative z-10">
            <div className="flex items-center gap-2 text-white/70 text-sm mb-4">
              <Link to="/" className="hover:text-white">{tx("Kryefaqe")}</Link><span>/</span>
              <Link to="/blog" className="hover:text-white">Blog</Link><span>/</span>
              <span className="text-white line-clamp-1">{post.title}</span>
            </div>
            <h1 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold" style={{ fontFamily: "'Noto Sans', sans-serif" }} data-testid="blog-post-title">{post.title}</h1>
          </div>
          {/* Right - image */}
          <div className="hidden lg:block relative p-4">
            <img src={imgSrc} alt={post.title} className="w-full h-full object-cover object-top" style={{ borderRadius: '10px' }} />
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-6 md:px-12 max-w-[1350px] mx-auto">
        <div className="text-[#4A5568] leading-relaxed whitespace-pre-line text-base max-w-[1350px]">{post.content}</div>
      </section>

      {/* Related */}
      {related.length > 0 && (
        <section className="py-16 px-6 md:px-12 max-w-[1350px] mx-auto bg-[#FAFAFA]">
          <h2 className="text-xl font-bold mb-6" style={{ color: 'rgb(28,163,176)', fontFamily: "'Noto Sans', sans-serif" }}>{tx("Artikuj te ngjashem")}</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {related.map(p => (
              <Link key={p.id} to={`/blog/${p.id}`} className="bg-white rounded-xl overflow-hidden border border-slate-200 hover:shadow-lg transition-shadow">
                <div className="h-40 overflow-hidden">
                  <img src={p.cover_image?.startsWith("/api/files/") ? `${process.env.REACT_APP_BACKEND_URL}${p.cover_image}` : p.cover_image || 'https://images.pexels.com/photos/23625648/pexels-photo-23625648.jpeg'} alt={p.title} className="w-full h-full object-cover object-top" />
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-sm text-[#0A0D10] line-clamp-2">{p.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default BlogPostPage;
